import { BusinessDetailForm } from './BusinessDetailForm';
import { IndividualDetailForm } from './IndividualDetailForm';

interface DetailFormProps {
  readonly businessType: 'individual' | 'business';
}

function DetailForm({ businessType }: DetailFormProps) {
  return businessType === 'business' ? <BusinessDetailForm /> : <IndividualDetailForm />;
}

export { DetailForm };
